import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../models/user';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MailingService {
  protected basePath = `${environment.apiUrl}/api/nodemailer`;

  constructor(private http: HttpClient) {}

  /**
   * Sends a test mail.
   * @returns Observable with server response
   */
  sendTest(): Observable<any> {
    const url = `${this.basePath}/test`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(url, {}, { headers });
  }

  /**
   * Sends the forgot-password email with a security token.
   * @param username The username
   * @returns Observable with server response
   */
  sendForgotPasswordMail(username: string): Observable<any> {
    const url = `${this.basePath}/forgotPassword`;
    const body = { username };
    console.log('sendForgotPasswordMail', body, url);
    return this.http.post<any>(url, body);
  }

  /**
   * Sends a notification for new users including an initial password-reset link.
   * @param user The user details (e.g., name, email)
   * @returns Observable with server response
   */
  sendNewUserMail(user: User): Observable<any> {
    console.log(user, 'sendNewUserMail');
    const url = `${this.basePath}/newUser`;
    const body = { user };
    return this.http.post(url, body);
  }
}
